export const ManualPaymentIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.63336 6.66666H6.70003"
            stroke="#FF9A09"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14 6V12C14 12.1768 13.9297 12.3464 13.8047 12.4714C13.6797 12.5964 13.5101 12.6667 13.3333 12.6667H3.33331"
            stroke="#FF9A09"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.66665 10L10.6666 10C11.0348 10 11.3333 9.70152 11.3333 9.33333V4C11.3333 3.63181 11.0348 3.33333 10.6666 3.33333L2.66665 3.33333C2.29846 3.33333 1.99998 3.63181 1.99998 4V9.33333C1.99998 9.70152 2.29846 10 2.66665 10Z"
            stroke="#FF9A09"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
